import React from 'react';
import { Button as RButton, Spinner } from 'reactstrap';

interface ButtonProps {
  label: string;
  color?: string;
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
}

const GMButton = ({
  label,
  color = 'success',
  className,
  onClick,
  disabled,
  loading,
  icon: Icon
}: ButtonProps) => (
  <RButton color={color} className={className} onClick={onClick} disabled={disabled}>
    {loading && <Spinner size="sm" />}
    {Icon}
    {label}
  </RButton>
);

export default GMButton;
